<template>
    <div id="sale-view">
        <div class="layout">
            <div class="header">
                <top-header :title="month + '月销售业绩看板'" />
            </div>

            <div class="content">

                <!-- 左侧部分 -->
                <div class="left">
                    <div class="left-box-item">

                        <div class="left-item1">
                            <!-- <div class="item-title">2月</div> -->
                            <SaleTitle title="门店销售目标前/后5" />
                            <div class="item-content item-border">
                                <DataTable :header="itembranch" :data="BranchTop" />
                            </div>
                        </div>

                        <div class="left-item2">
                            <!-- <div class="item-title">2月</div> -->
                            <SaleTitle title="类别销售目标前/后5" />
                            <div class="item-content item-border">
                                <DataTable :data="CategoryTop" :header="itemcls" />
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 中间部分 -->
                <div class="center">

                    <div class="center-item">

                        <div class="center-item1">
                            <div class="center-item1-top">
                                <div class="center-amt">{{ SaleAmount }}</div>

                                <div class="center-amt-c"></div>

                                <div class="center-amt-b">
                                    <el-row style="display: flex;align-items: center;">
                                        <el-col :span="6" style="text-align: right;">本月达成率:</el-col>
                                        <el-col :span="6" style="text-align: left;padding-left: 10px;">{{ Persent }}%</el-col>
                                        <el-col :span="6" style="text-align: right;">月环比:</el-col>
                                        <el-col :span="6" style="text-align: left;padding-left: 10px;">{{ Rate }}%</el-col>

                                    </el-row>
                                </div>

                            </div>

                            <div class="center-item1-bottom">
                                <el-row style="height: 100%;">
                                    <el-col class="custom-bottom s-left" :span="8">
                                        <div class="sort">
                                            <div class="sort-icon sort-icon-left"></div>
                                            <div class="sort-content">
                                                <div v-if="BranchTop && BranchTop[1]">{{ BranchTop[1].name }}</div>
                                                <div v-if="BranchTop && BranchTop[1]"
                                                    style="font-size: 1.8vw;margin-top: 0.2vh;">
                                                    {{ BranchTop[1].Persent }}%</div>

                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col class="custom-bottom s-center" :span="8">
                                        <div class="sort">
                                            <div class="sort-icon-center"></div>
                                            <div class="sort-content">
                                                <div v-if="BranchTop && BranchTop[0]">{{ BranchTop[0].name }}</div>
                                                <div v-if="BranchTop && BranchTop[0]"
                                                    style="font-size: 1.8vw;margin-top: 0.2vh;">
                                                    {{ BranchTop[0].Persent }}%</div>

                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col class="custom-bottom s-right" :span="8">
                                        <div class="sort">
                                            <div class="sort-icon sort-icon-right"></div>
                                            <div class="sort-content">
                                                <div v-if="BranchTop && BranchTop[2]">{{ BranchTop[2].name }}</div>
                                                <div v-if="BranchTop && BranchTop[2]"
                                                    style="font-size: 1.8vw;margin-top: 0.2vh;">
                                                    {{ BranchTop[2].Persent }}%</div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>

                            </div>
                        </div>

                        <div class="center-item2">
                            <!-- <div class="item-title">2月</div> -->
                            <SaleTitle title="月度总销售指标" />

                            <div class="item-content item-border">
                                <!-- <div style="height: 3vh;"></div> -->
                                <div style=" position: relative;top: 4.84211vh;height:calc(100% - 2.52632vh);">
                                    <SalesChart ref="sale" :data="MonthSales" />
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <!-- 右侧部分 -->
                <div class="right">

                    <div class="right-item">

                        <div class="right-item1">
                            <!-- <div class="item-title">2月</div> -->
                            <SaleTitle title="品牌销售目标前/后5" />
                            <div class="item-content item-border">
                                <DataTable :header="itembrand" :data="BrandTop" />


                            </div>
                        </div>

                        <div class="right-item2">
                            <!-- <div class="item-title">2月</div> -->
                            <SaleTitle title="课组销售目标前/后5" />

                            <div class="item-content item-border">
                                <DataTable :header="itemke" :data="KeGroupTop" />


                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import topHeader from '../topHeader';
import SalesChart from './SalesChart';
import DataTable from './DataTable';
import SaleTitle from '@/components/Common/SaleTitle.vue';
import {
    gettopperformancebranch, gettopperformancebrand, gettopperformancegroup,
    gettopperformancecategory, getmonthsalessummary
} from '@/api/salesperformance.js';
import {
    getmonthsalesachievement

} from '@/api/salesummary.js';

export default {
    name: 'BranchSale',
    components: {
        topHeader,
        SalesChart,
        DataTable,
        SaleTitle
    },
    data() {
        return {
            itembranch: [{ title: '序号', width: 4 }, { title: '门店', width: 8 }, { title: '月销量额(元)', width: 6 }, { title: '月完成率', width: 6 }],
            itemcls: [{ title: '序号', width: 4 }, { title: '类别', width: 8 }, { title: '月销量额(元)', width: 6 }, { title: '月完成率', width: 6 }],
            itembrand: [{ title: '序号', width: 4 }, { title: '品牌', width: 8 }, { title: '月销量额(元)', width: 6 }, { title: '月完成率', width: 6 }],
            itemke: [{ title: '序号', width: 4 }, { title: '课组', width: 8 }, { title: '月销量额(元)', width: 6 }, { title: '月完成率', width: 6 }],
            BranchTop: [],
            CategoryTop: [],
            BrandTop: [],
            KeGroupTop: [],
            MonthSales: {},
            month: '',
            SaleAmount: 0,
            Persent: 0,
            Rate: 0
        };
    },
    mounted() {
        // 监听不同浏览器的全屏状态变化事件

        window.addEventListener('resize', this.handleFullscreenChange);
        this.getData();

    },
    beforeDestroy() {
        // 移除事件监听器，防止内存泄漏

        window.removeEventListener('resize', this.handleFullscreenChange);

    },
    methods: {
        handleFullscreenChange() {

            // 获取容器元素
            this.$refs.sale.chart.resize();
        },
        getData() {
            // 获取当前日期
            const now = new Date();
            // 获取当前年份
            const year = now.getFullYear();
            // 获取当前月份（注意：月份从 0 开始计数，所以需要加 1）
            const month = now.getMonth() + 1;
            this.month = month;
            // 获取当月第一天
            const firstDay = new Date(year, month - 1, 2).toISOString().split('T')[0];
            // 获取当月最后一天
            const lastDay = new Date(year, month, 1).toISOString().split('T')[0];


            let param = {

                OperDateStart: firstDay,
                OperDateEnd: lastDay,
            };

            gettopperformancebranch(param).then(res => {
                let { Code, Data } = res;

                if (Code == 0) {
                    Data.forEach(item => {
                        this.BranchTop.push({
                            index: item.SaleRank,
                            name: item.BranchName,
                            amount: item.SaleAmount,
                            sales: item.SaleQty,
                            Persent: item.Persent * 100,
                            change: item.RankChange
                        })
                    })
                    console.log('Data', Data);

                }
            })

            // getdaysaleanalysis(param).then(res => {
            //     console.log(res);
            // })

            gettopperformancecategory(param).then(res => {
                console.log(res);
                let { Code, Data } = res;

                if (Code == 0) {
                    Data.forEach(item => {
                        this.CategoryTop.push({
                            index: item.SaleRank,
                            name: item.CategoryName,
                            amount: item.SaleAmount,
                            sales: item.SaleQty,
                            Persent: item.Persent * 100,
                            change: item.RankChange
                        })
                    })
                }
            })

            gettopperformancebrand(param).then(res => {
                console.log(res);
                let { Code, Data } = res;

                if (Code == 0) {
                    Data.forEach(item => {
                        this.BrandTop.push({
                            index: item.SaleRank,
                            name: item.BrandName,
                            amount: item.SaleAmount,
                            sales: item.SaleQty,
                            Persent: item.Persent * 100,
                            change: item.RankChange
                        })
                    })
                }
            })

            gettopperformancegroup(param).then(res => {
                console.log(res);
                let { Code, Data } = res;

                if (Code == 0) {
                    Data.forEach(item => {
                        this.KeGroupTop.push({
                            index: item.SaleRank,
                            name: item.KeGroupName,
                            amount: item.SaleAmount,
                            sales: item.SaleQty,
                            Persent: item.Persent * 100,
                            change: item.RankChange
                        })
                    })
                }
            })

            getmonthsalesachievement(param).then(res => {
                let { Code, Data } = res;

                if (Code == 0) {
                    //千分位补充逗号
                    this.SaleAmount = Data.SaleAmount.toLocaleString();
                    this.Persent = (Data.Persent * 100).toFixed(2);
                    this.Rate = (Data.Rate * 100).toFixed(2);

                }

            })


            // 获取今年第一天
            const firstDayOfYear = this.$moment().startOf('year').format('YYYY-MM-DD');
            const toDay = new Date().toISOString().split('T')[0];
            let param1 = {
                OperDateStart: firstDayOfYear,
                OperDateEnd: toDay,
            };
            getmonthsalessummary(param1).then(res => {
                console.log(res);
                let { Code, Data } = res;

                if (Code == 0) {
                    this.MonthSales = Data;
                    this.MonthSales.Current.forEach(item => {
                        item.OperDate = item.OperDate.split('-')[1]
                    })
                    this.MonthSales.Compare.forEach(item => {
                        item.OperDate = item.OperDate.split('-')[1]
                    })


                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
body {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0
}

#sale-view {

    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('../img/img_bg.png');
    background-size: 100% 100%;
}

.layout {
    // background-color: #010A59;
    color: #fff;
    height: 100%;
}

.header {
    width: 100%;
    height: 10.83703vh;
}

.content {
    align-items: center;
    display: flex;
    height: calc(100% - 10.83703vh);
    padding: 0 1.01041vw 1.01041vw;
}

.item-border {
    overflow: hidden;
    background: rgba(24, 50, 148, 0.30);
    border: none;
    border-radius: 8px;
}

.item-border::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 8px;
    background: linear-gradient(156deg, rgba(255, 255, 255, 0.3) 8%, rgba(255, 255, 255, 0.00) 91%);
    mask:
        linear-gradient(#221f1f 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    padding: 1px;
    /* 边框宽度 */
}

.left {
    width: 26.14583vw;
    height: 100%;
}

.left-box-item {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.left-item1 {
    flex: 1;
    width: 100%;
    margin-bottom: 2.10526vh;
    // 内容居中
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}

.item-title {
    font-size: 1.25vw;
    font-weight: bold;
    text-align: center;
    background-image: url('../img/img_title.png');
    height: 5.68421vh;
    background-size: 100% 100%;
    z-index: 99;
    /* 设置 position 为 relative 或 absolute，使 z-index 生效 */
    position: relative;
    width: 25vw;
    padding-top: 1vh;
    margin: 0 auto;
}

.item-content {
    position: relative;
    top: -3.15789vh;
    height: calc(100% - 2.52632vh);
    // height: 100%;
    padding-top: 3.15789vh;
    z-index: 1;
    width: 100%;
}


.left-item2 {
    width: 100%;
    flex: 1;
}


.center {
    flex: 1;
    height: 100%;
    margin: 0 1.14583vw;
}

.center-item {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.center-item1 {
    flex: 1;
    width: 100%;
    margin-bottom: 2.10526vh;
    display: flex;
    flex-direction: column;
}

.center-amt {
    width: 100%;
    height: 11vh;
    font-weight: bold;
    text-align: center;
    color: #fd8a2a;
    font-size: 3.64583vw;
    padding-top: 1.5vh;
    font-family: Roboto, Roboto-Bold;

}

.center-amt-c {
    //渐变背景 中间深 两边浅
    background: linear-gradient(90deg, rgba(61, 61, 61, 0) 0%, rgba(255, 255, 255, 0.5) 55%, rgba(255, 255, 255, 0) 100%);
    width: 80%;
    height: 2px;
    margin: 0 auto;
}

.center-amt-b {
    width: 80%;
    padding-top: 1.5vh;
    flex: 1;
    margin: 3px auto;
}

.center-item1-top {
    height: 19vh;
    width: 100%;
    margin-top: 2.10526vh;
    margin-bottom: 2.10526vh;
    background-image: url('../img/img_top.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
}

.center-item1-bottom {
    // flex: 1;
    width: 100%;
    height: 19vh;
}

.center-item2 {
    flex: 1;
    width: 100%;

}

.card-list {
    display: flex;
    flex-wrap: wrap;
}

.amt-card-double:nth-last-child(2n) {
    margin-right: .52083vw;
}

.amt-card-single:nth-last-child(2n) {
    margin-right: .52083vw;
}

.amt-card-double:nth-last-child(odd) {
    margin-left: .52083vw;
}

.amt-card-single:nth-last-child(odd) {
    margin-left: .52083vw;
}

.amt-card-double {
    align-items: center;
    background: rgba(24, 50, 148, 0.30);
    border: 1px solid;
    border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
    border-radius: 8px;
    height: 14.94736vh;
    // margin-top: 2.10526vh;
    width: calc(50% - .52083vw);
    display: flex;
    flex-direction: row;
    // background-color: yellow;
}

.card-left {
    display: flex;
    align-items: center;
    width: 5.625vw;
    height: 100%;
    //居中
    justify-content: center;
}

.card-right {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    font-size: 1.2vw;
}

.card-single-right {
    display: flex;
    flex-direction: row;
    flex: 1;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    margin: 1vw;
    font-size: 1.2vw;

}

.card-right-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1vw;
}

.card-right-center {
    height: 0.1vw;
    opacity: 0.3;
    margin: 0 1vw;
    /* 修改为中间深两边浅的渐变 */
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, #969595 35%, rgba(255, 255, 255, 0.06) 100%);
}

.card-right-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1vw;
}

.lf-icon-1 {
    width: 3.5vw;
    height: 3.5vw;
    border-radius: 1.8vw;
    background-color: #FFA837;
    //image居中
    background-image: url('../img/ic_plus-m.png');
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center;
}

.lf-icon-2 {
    width: 3.5vw;
    height: 3.5vw;
    border-radius: 1.8vw;
    background-color: #f22e2e;
    background-image: url('../img/ic_discount.png');
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center;
}

.lf-icon-3 {
    width: 3.5vw;
    height: 3.5vw;
    border-radius: 1.8vw;
    background-color: #14d85d;
    background-image: url('../img/ic_price-list.png');
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center;
}

.lf-icon-4 {
    width: 3.5vw;
    height: 3.5vw;
    border-radius: 1.8vw;
    background-color: #0088f0;
    background-image: url('../img/ic_return-og.png');
    background-size: 50% 50%;
    background-repeat: no-repeat;
    background-position: center;
}

.amt-card-single {
    align-items: center;
    background: rgba(24, 50, 148, 0.30);
    border: 1px solid;
    border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
    border-radius: 8px;
    width: calc(50% - .52083vw);
    // background-color: green;
    height: 11.11405vh;
    margin-top: 2.10526vh;
    display: flex;
    flex-direction: row;
}

.center-item3 {
    // flex: 1;
    width: 100%;
    height: calc(100% - 46.54386vh);
    // background-color: red;
}

.right {
    width: 26.14583vw; //25.9375vw;
    height: 100%;
}

.right-item {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.right-item1 {
    flex: 1;
    width: 100%;
    // background-color: yellow;
    margin-bottom: 2.10526vh;

}

.right-item2 {
    flex: 1;
    width: 100%;
    // background-color: red;

}

.el-row {
    margin-bottom: 0px !important;
}

.sort-content {
    top: 1.2vh;
    position: relative;
}

.sort {
    width: 10.5vw;
    height: 14.22105vh;
    display: flex;
    flex-direction: column;
    background: rgba(24, 50, 148, 0.30);
    border: 1px solid;
    border-image: linear-gradient(153deg, rgba(255, 255, 255, 0.30), rgba(255, 255, 255, 0.00) 83%) 1 1;
    border-radius: 8px;
    position: relative;
    justify-content: center;
    align-items: center;

    font-size: 1.2vw;
    font-weight: Regular;
    text-align: center;
    color: #ffffff;
}

.sort-icon {
    position: absolute;
    top: -4.5vh;
    width: 6.25vw;
    height: 4.89583vw;
}

.sort-icon-left {

    background-image: url('../img/img_02.png');
    background-size: 100% 100%;

}

.sort-icon-right {

    background-image: url('../img/img_03.png');
    background-size: 100% 100%;

}

.sort-icon-center {
    position: absolute;
    top: -6vh;
    background-image: url('../img/img_01.png');
    background-size: 100% 100%;
    width: 7.29166vw;
    height: 5.46875vw;
}

.custom-bottom {
    display: flex;
    align-items: flex-end;
    height: 100%;
}

.s-left {
    justify-content: flex-start;
}

.s-center {
    justify-content: center;
}

.s-right {
    justify-content: flex-end;

}
</style>